import { Col, Row } from 'reactstrap'

const FooterSobre = () => {
  return (
    <footer>
      <div className="container">
        <Row>
          <Col className="py-5">
            <img
              src="https://imagens-site-riber.s3.sa-east-1.amazonaws.com/logo_2.png"
              height={30}
            />
          </Col>
        </Row>
        <div className="informacoes">
          <span>
            O <strong>Grupo Riber</strong> é composto por empresas que atuam de
            forma integrada nos segmentos de crédito, seguros, consórcios e
            serviços financeiros, todas registradas e com sede no Estado de São
            Paulo. Integram o grupo as seguintes sociedades empresárias
            limitadas:&nbsp;
            <strong>Ribercred Serviços de Informações Cadastrais Ltda.</strong>,
            inscrita no CNPJ sob nº <strong>04.380.132/0001-47</strong> de na
            Avenida Antônio Diederichsen, 400, Sala 16, Edifício Metropolitan,
            Jardim América, Ribeirão Preto/SP, CEP 14020-250;&nbsp;
            <strong>RP Serviços de Informações Cadastrais Ltda.</strong>,
            CNPJ&nbsp;
            <strong>07.677.411/0001-65</strong>, situada na Avenida Antônio
            Diederichsen, 400, Sala 17, Edifício Metropolitan, Jardim América,
            Ribeirão Preto/SP, CEP 14020-250;&nbsp;
            <strong>Corban Serviços de Informações Cadastrais Ltda.</strong>,
            CNPJ <strong>11.459.595/0001-64</strong>, localizada na Avenida Cel.
            Quito Junqueira, 78, Campos Elíseos, Ribeirão Preto/SP, CEP
            14085-610;&nbsp;
            <strong>Alves e Zanchetta Serviços Cadastrais Ltda.</strong>,
            CNPJ&nbsp;
            <strong>12.565.686/0001-47</strong>, com sede na Rua 20, nº 877,
            Centro, Barretos/SP, CEP 14780-070; e&nbsp;
            <strong>RBC Serviços de Informações Cadastrais Ltda.</strong>,
            CNPJ&nbsp;
            <strong>20.362.665/0001-52</strong>, situada na Avenida Antônio
            Diederichsen, 400, Sala 106, Jardim América, Ribeirão Preto/SP, CEP
            14020-250. Todas as empresas possuem situação cadastral ativa e
            representam a base jurídica e operacional do Grupo Riber.
          </span>
        </div>
      </div>
    </footer>
  )
}

export default FooterSobre
